<template>
  <div class="ms-container">
    <acts-page type="contragent" />
  </div>
</template>

<script>
import ActsPage from '@/components/acts/acts-page'

export default {
  components: {
    ActsPage
  }
}
</script>

<style></style>
